import { CloudStore } from "@omni/types/api/store/cloud/store.model";

import { generateDefaultSelectors } from "@/redux/selectors.utils";
import { IState } from "@/redux/store.types";
import { getApiDataState } from "@/redux/utils";
import { GetStoreStrategy } from "@/services/store.service";

import { getDiscriminator } from "./preferredStore.discriminators";
import { $PreferredStoreModuleName } from "./preferredStore.types";

const { isLoading } = generateDefaultSelectors($PreferredStoreModuleName);

const getStore = (strategy: GetStoreStrategy, sku?: string) => {
    const discriminator = getDiscriminator({
        strategy: strategy,
        sku: sku
    });

    return (state: IState) => {
        const preferredStoreState = getApiDataState(
            state,
            $PreferredStoreModuleName
        ) as Record<string, { data: CloudStore | undefined }>;

        const discriminatedPreferredStoreState =
            preferredStoreState?.[discriminator];

        return discriminatedPreferredStoreState?.data;
    };
};

const hasError = (state: IState) =>
    !!getApiDataState(state, $PreferredStoreModuleName)?.error;

export { getStore, hasError, isLoading };
